angular.module('picmonicng').directive('dashboardTiles', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div class="dashboard-tiles"><dashboard-tile ng-repeat="tile in tiles | filter:{tile_type: \'!beta-access\'} | orderBy:\'sort_order\'"></dashboard-tile></div>',
      link: function (scope, elem, attrs) {
        scope.determineTilePositions = function () {
          if (window.innerWidth > 695) {
            var wrapper = elem;
            var tiles = wrapper.find('.dashboard-tile');

            var tilePositions = []; // Array of columns containing arrays of tiles
            var firstRow = true;
            var column = 0;

            // Determine the position of each tile
            tiles.each(function () {
              var tile = angular.element(this);
              var tileWidth = tile.width() + parseFloat(tile.css('margin-left')) + parseFloat(tile.css('margin-right'));
              var top = 0;
              var left = 0;

              // If there is a tile that precedes this one, determine how this tile fits around it
              if (tile.prev().length) {
                var previousTile = tile.prev();

                var previousTileWidth =
                  previousTile.width() +
                  parseFloat(previousTile.css('margin-left')) +
                  parseFloat(previousTile.css('margin-right'));

                // If we are still building the first row of tiles, determine if this tile can fit on the row
                if (firstRow && previousTile.position().left + previousTileWidth + tileWidth <= wrapper.width()) {
                  left = previousTile.position().left + previousTileWidth + 1;

                  tilePositions[column] = [tile];

                  column++;
                } else {
                  // Since this tile cannot fit on the first row, figure out which column it will fit best by determining the current shortest column
                  firstRow = false;

                  var shortestColumnHeight;
                  var shortestColumnIndex;

                  for (var a in tilePositions) {
                    // Loop through the columns
                    var columnHeight = 0;

                    for (var b in tilePositions[a]) {
                      // Loop through each tile in this column
                      columnHeight +=
                        tilePositions[a][b].height() +
                        parseFloat(tilePositions[a][b].css('margin-top')) +
                        parseFloat(tilePositions[a][b].css('margin-bottom'));
                    }

                    if (!shortestColumnIndex || columnHeight < shortestColumnHeight) {
                      shortestColumnIndex = a;
                      shortestColumnHeight = columnHeight;
                    }
                  }

                  // Add this tile to the shortest column, set left and top position
                  tilePositions[shortestColumnIndex].push(tile);

                  left = tilePositions[shortestColumnIndex][0].position().left;
                  top = shortestColumnHeight;
                }
              } else {
                //Since there is no previous tile, assume it's the first tile and add it to the first column, first row
                tilePositions[column] = [tile];
                column++;
              }

              tile.css({ top: top, left: left });
            });
          }
        };

        angular.element(window).resize(function () {
          scope.determineTilePositions();
        });
      },
    };
  },
]);
